import React, { useEffect, useState } from "react";
import "./LoanDetails.css";
import {
  FormControl,
  OutlinedInput,
  InputAdornment,
  Select,
  MenuItem,
} from "@mui/material";

const LoanDetails = ({ onCheck }) => {
  const [loanBalance, setLoanBalance] = useState(25000);
  const [monthlyPayment, setMonthlyPayment] = useState(1000);
  const [annualRate, setAnnualRate] = useState(7.5);
  const [loanTermYears, setLoanTermYears] = useState(5);

  const currencyFormatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
  });

  const formatCurrency = (value) => {
    return value.toLocaleString("en-IN");
  };

  const handleAmountChange = (e, setter) => {
    const value = e.target.value.replace(/,/g, ""); // Remove commas
    if (/^\d*\.?\d*$/.test(value)) {
      // Allow only numbers and a single decimal point
      setter(Number(value));
    }
  };

  const calculateLoan = () => {
    const monthlyRate = annualRate / 100 / 12;
    const nPayments = loanTermYears * 12;
    const payment =
      (loanBalance * monthlyRate * Math.pow(1 + monthlyRate, nPayments)) /
      (Math.pow(1 + monthlyRate, nPayments) - 1);

    const roundedPayment = isNaN(payment) ? 0 : Math.round(payment);
    const savings = isNaN(monthlyPayment - roundedPayment)
      ? 0
      : Math.round(monthlyPayment - roundedPayment);

    const formData = {
      loanBalance: currencyFormatter.format(loanBalance),
      roundedPayment: currencyFormatter.format(roundedPayment),
      savings: currencyFormatter.format(savings),
    };
    onCheck(formData);
  };
  useEffect(() => {
    calculateLoan();
  }, [loanBalance, monthlyPayment, annualRate, loanTermYears]);

  return (
    <>
      <div
        id="loan_details__container"
        className=" loan_details__content__box rounded py-4 px-3"
      >
        <div className="d-flex flex-column gap-1">
          <div className="details_box p-2">
            <p className="debt_consolidation_details__label archivo mb-1">
              Loan Balance
            </p>
            <FormControl
              fullWidth
              sx={{
                backgroundColor: "#ffffff",
                border: "1.5px solid #b783cc",
                borderRadius: "5px",
                paddingTop: "0px",
                fontFamily: "'Archivo',sans-serif",
              }}
            >
              <OutlinedInput
                id="outlined-adornment-amount"
                fullWidth
                size="small"
                startAdornment={
                  <InputAdornment position="start">
                    <span className="archivo">&#8377;</span>
                  </InputAdornment>
                }
                value={formatCurrency(loanBalance)} // Display value with commas
                onChange={(e) => handleAmountChange(e, setLoanBalance)}
              />
            </FormControl>
          </div>
          <div className="details_box p-2">
            <p className="debt_consolidation_details__label archivo mb-1">
              Monthly Payment
            </p>
            <FormControl
              fullWidth
              sx={{
                backgroundColor: "#ffffff",

                border: "1.5px solid #b783cc",
                borderRadius: "5px",
                paddingTop: "0px",
                fontFamily: "'Archivo',sans-serif",
                "& .MuiInputBase-input": {
                  fontFamily: "'Archivo',sans-serif",
                },
              }}
            >
              <OutlinedInput
                id="outlined-adornment-amount"
                fullWidth
                size="small"
                sx={{
                  fontFamily: "'Archivo',sans-serif",
                }}
                startAdornment={
                  <InputAdornment position="start">
                    <span className="archivo">&#8377;</span>
                  </InputAdornment>
                }
                value={formatCurrency(monthlyPayment)} // Display value with commas
                onChange={(e) => handleAmountChange(e, setMonthlyPayment)}
              />
            </FormControl>
          </div>
          <div className="details_box p-2">
            <p className="debt_consolidation_details__label archivo mb-1">
              Consolidation Loan Rate
            </p>
            <FormControl
              fullWidth
              sx={{
                backgroundColor: "#ffffff",

                border: "1.5px solid #b783cc",
                borderRadius: "5px",
                paddingTop: "0px",
                fontFamily: "'Archivo',sans-serif",
                "& .MuiInputBase-input": {
                  fontFamily: "'Archivo',sans-serif",
                },
              }}
            >
              <OutlinedInput
                id="outlined-adornment-amount"
                fullWidth
                size="small"
                sx={{
                  fontFamily: "'Archivo',sans-serif",
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <span className="archivo">%</span>
                  </InputAdornment>
                }
                value={annualRate || 0}
                onChange={(e) => {
                  let value = e.target.value.replace(/,/g, "");
                  if (/^\d*\.?\d*$/.test(value)) {
                    if (value === "") {
                      setAnnualRate("");
                    } else {
                      setAnnualRate(value.replace(/^0+/, "") || "0");
                    }
                  }
                }}
                onFocus={() => annualRate === "0" && setAnnualRate("")}
                onBlur={() =>
                  setAnnualRate(annualRate === "" ? "0" : annualRate)
                }
              />
            </FormControl>
          </div>
          <div className="details_box p-2">
            <p className="debt_consolidation_details__label archivo mb-1">
              Loan Term
            </p>
            <FormControl
              fullWidth
              sx={{
                backgroundColor: "#ffffff",

                border: "1.5px solid #b783cc",
                borderRadius: "5px",
                paddingTop: "0px",
                fontFamily: "'Archivo',sans-serif",
                "& .MuiInputBase-input": {
                  fontFamily: "'Archivo',sans-serif",
                },
              }}
            >
              <Select
                size="small"
                value={loanTermYears}
                onChange={(e) => setLoanTermYears(e.target.value)}
              >
                <MenuItem value={1}>1 Year Term</MenuItem>
                <MenuItem value={2}>2 Year Term</MenuItem>
                <MenuItem value={3}>3 Year Term</MenuItem>
                <MenuItem value={4}>4 Year Term</MenuItem>
                <MenuItem value={5}>5 Year Term</MenuItem>
                <MenuItem value={6}>6 Year Term</MenuItem>
                <MenuItem value={7}>7 Year Term</MenuItem>
                <MenuItem value={8}>8 Year Term</MenuItem>
                <MenuItem value={9}>9 Year Term</MenuItem>
                <MenuItem value={10}>10 Year Term</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoanDetails;
